import { Component, EventEmitter, Output } from '@angular/core';
import {
  ImageCroppedEvent,
  ImageTransform,
  LoadedImage,
} from 'ngx-image-cropper';

@Component({
    selector: 'c-crop-image',
    templateUrl: './crop-image.component.html',
    styleUrl: './crop-image.component.css',
    standalone: false
})
export class CropImageComponent {
  visible = false;
  open() {
    this.visible = true;
  }
  close() {
    this.imageChangedEvent = null;
    this.croppedImage = '';
    this.canvasRotation = 0;
    this.transform = {};
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.currentX = 0;
    this.currentY = 0;

    this.zoom = 1;
    this.visible = false;
  }

  @Output() btnClick = new EventEmitter<string>();
  onButtonClick() {
    this.btnClick.emit(this.croppedImage!);
  }

  imageChangedEvent: Event | null = null;
  croppedImage = '';

  // private readonly sanitizer = inject(DomSanitizer);

  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.objectUrl ?? '';

    // event.blob can be used to upload the cropped image
  }

  imageLoaded(image: LoadedImage) {
    const i = document.querySelectorAll('.ngx-ic-source-image');
    i.forEach((j) => {
      // Añadir los event listeners
      j.addEventListener('mousedown', (event: any) => {
        this.onMouseDown(event);
      });
      j.addEventListener('mousemove', (event: any) => {
        this.onMouseMove(event);
      });
      j.addEventListener('mouseup', () => {
        this.onMouseUp();
      });
      j.addEventListener('mouseleave', () => {
        this.onMouseUp();
      });
    });
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  canvasRotation = 0;
  transform: ImageTransform = {};

  /** @description Rotamos la imagen a la izquierda */
  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }
  /** @description Rotamos la imagen a la derecha */
  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }
  /** @description Se usa antes de realizar la rotación para ajustar la imagen */
  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }

  zoomIn(): void {
    this.zoom += 0.1; // Aumenta el zoom
    this.transform = {
      ...this.transform,
      scale: this.zoom,
    };
  }

  zoomOut(): void {
    this.zoom -= 0.1; // Disminuye el zoom
    this.transform = {
      ...this.transform,
      scale: this.zoom,
    };
  }

  isDragging = false;
  startX = 0;
  startY = 0;
  currentX = 0;
  currentY = 0;

  zoom = 1;

  onMouseDown(event: MouseEvent): void {
    event.preventDefault(); // Evita el comportamiento predeterminado del navegador
    this.isDragging = true;
    this.startX = event.clientX - this.currentX;
    this.startY = event.clientY - this.currentY;
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.isDragging) return;

    // const container = event.target as HTMLElement;
    // const rect = container.getBoundingClientRect();
    // const maxX = rect.width;
    // const maxY = rect.height;

    // Calcula el desplazamiento actual
    // this.currentX = Math.min(0, Math.max(event.clientX - this.startX, -maxX));
    this.currentX = event.clientX - this.startX;
    // this.currentY = Math.min(0, Math.max(event.clientY - this.startY, -maxY));
    this.currentY = event.clientY - this.startY;

    this.transform = {
      ...this.transform,
      scale: this.zoom,
      translateH: this.currentX,
      translateV: this.currentY,
      translateUnit: 'px',
    };
  }

  onMouseUp(): void {
    this.isDragging = false;
  }
}
